// extracted by mini-css-extract-plugin
export default {"order":"OrdersList_order__P1MmN"};